// @flow
import { FEATURE_CUSTOM_REDUX_V3 } from "../../constant";
import {
    DEVICE_INFO_MESSAGES,
    DEVICE_INFO_MESSAGES_KEYS,
    INFO_CODE
} from "../../custom/components/deviceInfoMessage";
import { getLastKey, getStore } from "../../Utils";
import { sortObjWithAnotherKey } from "../../welcome-dashboard/Utils";
import {
    SET_AUTO_MANAGE_HOST_TRIGGER,
    SET_HOST_EVENT_RECEIVED,
    SET_HOST_HANGUP_AUTO_CONNECT,
    SET_HOST_HANGUP_EVENT_RECEIVED,
    SET_IS_DEVICE_CONNECTING,
    SET_IS_EVENT_REQUESTING_LOADER,
    SET_IS_MODERATOR_THIRD_PARTY_LISTEN,
    SET_IS_PARTICIPANT_THIRD_PARTY_LISTEN,
    SET_LOCAL_AUTO_CONNECT,
    SET_LOCAL_BUFFER_VALUE,
    SET_PREJOIN_AVAILABLE_DEVICES,
    SET_PREJOIN_DEVICE_MESSAGE,
    SET_PREJOIN_LOADER,
    SET_PREJOIN_STEPS_RUNNING,
    SET_PREJOIN_SUBSCRIPTION_UI,
    SET_IS_WEBSOCKET_RECONNECTING,
    SET_SHOW_RTA_JAM_INVITE_POPUP,
    SET_SHOW_RTA_JAM_EMAIL_INVITE_POPUP,
    SET_ALWAYS_SHOW_PRE_JOINING,
    SET_PREJOIN_DEVICE_PING_CALCULATE,
    SET_USER_STATIC_DEVICE_ID,
    SET_USER_PREJOIN_ALL_SET,
    SET_HIDE_WEBJAM_CONNECTED_MESSAGE,
    SET_TOUR_GUIDE_TYPE,
    SET_TOUR_GUIDE_VISIBILITY,
    SET_INVITED_USER_M_STATE,
    SET_SHOW_DEVICE_HELPING_GUIDE,
    SET_JAMMING_CAPABILITY_STATE,
    SET_INVITED_USER_CONFIRM,
    SET_PREJOIN_SCREEN_USER_ROUTE,
    SET_USER_MAKE_ROOM_PAYMENT,
    SET_MY_DEVICES_DATA,
    SET_IS_MIXER_MUTE_BY_DEFAULT,
    SET_IS_JOIN_AUDIO_TO_MUTE,
    SHOW_TUTORIAL_MODAL,
    SET_USER_HANGUP_STATUS,
    SET_CONFIRMATION_MODAL_PROPS,
    SET_SERVER_CONNECT_REHIT,
    SET_DISABLE_VIEW_TOGGLE,
    SET_LIVE_STREAMING_STATUS,
    SET_PREJOIN_DEVICE_CONNECT_TIME,
    SET_DEVICE_ERROR_INFO,
    SET_IS_CHINA_REGION,
    SET_SHOW_DEVICE_PREJOIN_CONNECTION,
    SET_PREJOIN_CONNECTION_STAMP,
    SET_DOWNLOAD_TITLE,
    SET_WHITEBOARD_OPEN_CLICKED,
    SET_PREMEETING_SUBSCRIPTION_UI,
    SET_IS_NAT_TYPE,
    SET_MANUAL_BOX_PROCESS,
    SET_IS_DISCONNECT_LISTENED,
    SET_SOUND_CARDS_LIST,
    SET_RECORDING_DETAILS,
    SET_HIT_FIREWALL_API,
} from "./actionType";


export function setAutoMakeHostTrigger(autoManageHostTrigger: Boolean) {
    return {
        type: SET_AUTO_MANAGE_HOST_TRIGGER,
        autoManageHostTrigger
    };
}

export function setLocalAutoConnect(localAutoConnect: Boolean) {
    return {
        type: SET_LOCAL_AUTO_CONNECT,
        localAutoConnect
    };
}

export function setIsDeviceConnecting(isDeviceConnecting: Boolean) {
    return {
        type: SET_IS_DEVICE_CONNECTING,
        isDeviceConnecting
    };
}

export function setParticipantThirdPartyEventListened(isParticipantThirdPartyListen: Boolean) {
    return {
        type: SET_IS_PARTICIPANT_THIRD_PARTY_LISTEN,
        isParticipantThirdPartyListen
    };
}

export function setModeratorThirdPartyEventListened(isModeratorThirdPartyListen: Boolean) {
    return {
        type: SET_IS_MODERATOR_THIRD_PARTY_LISTEN,
        isModeratorThirdPartyListen
    };
}

export function setIsEventRequestingLoader(isEventRequestingLoader: String) {
    return {
        type: SET_IS_EVENT_REQUESTING_LOADER,
        isEventRequestingLoader
    };
}

export function setHostEventReceived(hostEventReceived: String) {
    return {
        type: SET_HOST_EVENT_RECEIVED,
        hostEventReceived
    };
}

export function setHostHangupEventReceived(hostHangupEventReceived: Boolean, hangupActionType: Number) {
    return {
        type: SET_HOST_HANGUP_EVENT_RECEIVED,
        hostHangupEventReceived,
        hangupActionType
    };
}
export function setPrejoinLoader(showPrejoinLoader: Boolean) {
    return {
        type: SET_PREJOIN_LOADER,
        showPrejoinLoader
    };
}

export function setHostHangupAutoConnect(hostHangupAutoConnect: Boolean) {
    return {
        type: SET_HOST_HANGUP_AUTO_CONNECT,
        hostHangupAutoConnect
    };
}

export function setLocalBufferValue(localBuffervalue: Boolean) {
    return {
        type: SET_LOCAL_BUFFER_VALUE,
        localBuffervalue
    };
}

export function setPrejoinDeviceMessages(
    prejoinDeviceMessages: any,
    additional: any = null
) {
    // fix me i'm writing thunk functionality directly by access store here directly
    let allStoreV3 = getStore(FEATURE_CUSTOM_REDUX_V3);
    let latestValue = { ...prejoinDeviceMessages.messages };

    let getExisting = allStoreV3.prejoinDeviceMessages;

    let updatedMessages = {
        show: true,
        messages: {}
    };

    let lastKey = getLastKey(prejoinDeviceMessages.messages);

    let willUpdate = true;
    if (!additional) {
        if (getExisting.show) {
            let Obj = Object.keys(getExisting.messages);
            if (Obj.length) {
                for (let i = 0; i < Obj.length; i++) {
                    let ke = Obj[i];
                    let val = DEVICE_INFO_MESSAGES[ke];

                    updatedMessages.messages = Object.assign(
                        {
                            [ke]: val
                        },
                        updatedMessages.messages
                    );

                    // let willMove = true;
                    // if (lastKey) {
                    //   if(DEVICE_INFO_MESSAGES[lastKey].infoCode !=  val.infoCode){
                    //     willMove = false
                    //   }
                    // }

                    if (val.failed && !val.success) {
                        willUpdate = false;
                        break;
                    }
                }
            }
        }

        if (!willUpdate) {
            prejoinDeviceMessages = updatedMessages;
        }
    }

    prejoinDeviceMessages.messages = sortObjWithAnotherKey(
        prejoinDeviceMessages.messages,
        DEVICE_INFO_MESSAGES_KEYS
    );

    if (
        prejoinDeviceMessages.messages.hasOwnProperty(
            DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE
        )
    ) {
        if (
            prejoinDeviceMessages.messages[
                DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET
            ].loading == true
        ) {
            prejoinDeviceMessages.messages[
                DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET
            ] = {
                ...prejoinDeviceMessages.messages[
                DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET
                ],
                loading: false,
                success: true,
                failed: false
            };
        }
    }

    // if (prejoinDeviceMessages.messages.hasOwnProperty(DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION) && !prejoinDeviceMessages.messages.hasOwnProperty(DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE)) {
    //     try {
    //         delete prejoinDeviceMessages.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION]
    //     } catch (e) {
    //     }
    // }

    return {
        type: SET_PREJOIN_DEVICE_MESSAGE,
        prejoinDeviceMessages
    };
}

export function setPrejoinAvailableDevices(prejoinAvailableDevice: Array) {
    return {
        type: SET_PREJOIN_AVAILABLE_DEVICES,
        prejoinAvailableDevice
    };
}

export function setPrejoinDeviceStepRunning(
    prejoinDeviceStepsRunning: Boolean,
    prejoinDeviceStepsRunningFlag: any,
    lastPrejoinInfoCode: any
) {
    return {
        type: SET_PREJOIN_STEPS_RUNNING,
        prejoinDeviceStepsRunning,
        prejoinDeviceStepsRunningFlag,
        lastPrejoinInfoCode: lastPrejoinInfoCode || ""
    };
}

export function setPrejoinSubscriptionUI(prejoinSubscription: Object) {
    return {
        type: SET_PREJOIN_SUBSCRIPTION_UI,
        prejoinSubscription
    };
}

export function setIsWebsocketReconnecting(isWebsocketReconnecting: any) {
    return {
        type: SET_IS_WEBSOCKET_RECONNECTING,
        isWebsocketReconnecting
    };
}

export function setShowRtaJamInvitePopup(showRtaJamInvitePopup: Boolean) {
    return {
        type: SET_SHOW_RTA_JAM_INVITE_POPUP,
        showRtaJamInvitePopup
    };
}

export function setShowRtaJamEmailInvitePopup(
    showRtaJamEmailInvitePopup: Boolean
) {
    return {
        type: SET_SHOW_RTA_JAM_EMAIL_INVITE_POPUP,
        showRtaJamEmailInvitePopup
    };
}

export function setAlwaysShowPreJoining(alwaysShowPreJoining: Boolean) {
    return {
        type: SET_ALWAYS_SHOW_PRE_JOINING,
        alwaysShowPreJoining
    };
}

export function setPrejoinDevicePingCalculate(prejoinDevicePingCalculation: String) {
    return {
        type: SET_PREJOIN_DEVICE_PING_CALCULATE,
        prejoinDevicePingCalculation
    };
}

export function setUserStaticDeviceId(userBoxStaticDeviceId: String) {
    return {
        type: SET_USER_STATIC_DEVICE_ID,
        userBoxStaticDeviceId
    };
}
export function setUserPrejoinAllSet(userPrejoinAllSet: Boolean) {
    return {
        type: SET_USER_PREJOIN_ALL_SET,
        userPrejoinAllSet
    };
}

export function setHideWebjamConnectedMessage(hideWebjamConnectedMessage: Boolean) {
    return {
        type: SET_HIDE_WEBJAM_CONNECTED_MESSAGE,
        hideWebjamConnectedMessage
    };
}

export function setTourGuideType(tourGuideType: String) {
    return {
        type: SET_TOUR_GUIDE_TYPE,
        tourGuideType
    };
}

export function setTourGuideVisibility(tourGuideVisibility: String) {
    return {
        type: SET_TOUR_GUIDE_VISIBILITY,
        tourGuideVisibility
    };
}

export function setInvitedUserMState(isInvitedUserMState: Boolean) {
    return {
        type: SET_INVITED_USER_M_STATE,
        isInvitedUserMState
    };
}

export function setShowDeviceHelpingGuide(showDeviceHelpingGuide: Boolean) {
    return {
        type: SET_SHOW_DEVICE_HELPING_GUIDE,
        showDeviceHelpingGuide
    };
}

export function setJammingCapabilityState(isJammingCapability: Boolean) {
    return {
        type: SET_JAMMING_CAPABILITY_STATE,
        isJammingCapability
    };
}

export function setInvitedUserConfirm(invitedUserConfirm: String) {
    return {
        type: SET_INVITED_USER_CONFIRM,
        invitedUserConfirm
    };
}

export function setPrejoinScreenUserRoute(prejoinScreenUserRoute: String) {
    return {
        type: SET_PREJOIN_SCREEN_USER_ROUTE,
        prejoinScreenUserRoute
    };
}

export function setUserMakeRoomPayment(userMakeRoomPayment: Boolean) {
    return {
        type: SET_USER_MAKE_ROOM_PAYMENT,
        userMakeRoomPayment
    };
}

export function setMyDevicesData(myDevicesData: any) {
    return {
        type: SET_MY_DEVICES_DATA,
        myDevicesData
    }
}

export function setIsMixerMuteByDefault(isMixerMuteByDefault: Boolean) {
    return {
        type: SET_IS_MIXER_MUTE_BY_DEFAULT,
        isMixerMuteByDefault
    }
}

export function setIsPreJoinAudioToMute(isPreJoinAudioToMute: Boolean) {
    return {
        type: SET_IS_JOIN_AUDIO_TO_MUTE,
        isPreJoinAudioToMute
    }

}

export function showTutorialModal(showTutorial: boolean) {
    return {
        type: SHOW_TUTORIAL_MODAL,
        showTutorial
    }
}

export function setUserHangupStatus(userHangupStatus: String) {
    return {
        type: SET_USER_HANGUP_STATUS,
        userHangupStatus
    }
}

export function setConfirmationModalProps(propsObj: any) {
    return {
        type: SET_CONFIRMATION_MODAL_PROPS,
        confirmationModalProps: propsObj
    }
}

export function setServerConnectReHit(serverConnectRehit: Boolean) {
    return {
        type: SET_SERVER_CONNECT_REHIT,
        serverConnectRehit
    }
}

export function setDisableViewToggle(disableViewToggle: Boolean) {
    return {
        type: SET_DISABLE_VIEW_TOGGLE,
        disableViewToggle
    }
}

export function setLiveStreamingStatus(liveStreamingStatus: Boolean, streamingInitiator: string = "") {
    return {
        type: SET_LIVE_STREAMING_STATUS,
        liveStreamingStatus,
        streamingInitiator: streamingInitiator || ""
    }
}

export function setPrejoinDeviceConnectTime(prejoinDeviceConnectTime: Number) {
    return {
        type: SET_PREJOIN_DEVICE_CONNECT_TIME,
        prejoinDeviceConnectTime
    }
}

export function setBoxDeviceErrorInfo(boxDeviceErrorInfo: Object) {
    return {
        type: SET_DEVICE_ERROR_INFO,
        boxDeviceErrorInfo
    }
}

export function setIsChinaRegion(isChinaRegion: Boolean) {
    return {
        type: SET_IS_CHINA_REGION,
        isChinaRegion
    }
}
export function setShowDevicePreConnection(showDevicePreConnection: boolean) {
    return {
        type: SET_SHOW_DEVICE_PREJOIN_CONNECTION,
        showDevicePreConnection
    }
}
export function setPrejoinConnectionStamp(prejoinConnectStamp: Number) {
    return {
        type: SET_PREJOIN_CONNECTION_STAMP,
        prejoinConnectStamp
    }
}
export function setDownloadTitle(downloadTitle: string) {
    return {
        type: SET_DOWNLOAD_TITLE,
        downloadTitle
    }
}

export const setWhiteboardOpenClicked = (isWhiteboardOpenClicked: boolean) => {
    return {
        type: SET_WHITEBOARD_OPEN_CLICKED,
        isWhiteboardOpenClicked
    };
};

export const setPremeetingSubscriptionUI = (isPremeetingSubscriptionUI: boolean) => {
    return {
        type: SET_PREMEETING_SUBSCRIPTION_UI,
        isPremeetingSubscriptionUI
    };
};

export const setIsNatType = (isNatType: Object) => {
    return {
        type: SET_IS_NAT_TYPE,
        isNatType
    };
};

export const setManualBoxProcess = (manualBoxProcess: Object) => {
    return {
        type: SET_MANUAL_BOX_PROCESS,
        manualBoxProcess
    };
};

export const setIsDisconnectListened = (isDisconnectListened: Boolean) => {
    return {
        type: SET_IS_DISCONNECT_LISTENED,
        isDisconnectListened
    };
};

export const setSoundCardsList = (currentSoundCard: String, soundCards: Array) => {
    console.log("setSoundCardsList =>", currentSoundCard, soundCards)
    return {
        type: SET_SOUND_CARDS_LIST,
        currentSoundCard,
        soundCards
    };
};

export const setRecordingDetails = (recordingDetails: Object) => {
    return {
        type: SET_RECORDING_DETAILS,
        recordingDetails
    };
};

export const setHitFirewallApi = (hitFirewallApi: Boolean) => {
    return {
        type: SET_HIT_FIREWALL_API,
        hitFirewallApi
    };
};